import { toDate } from "./toDate";

export function getFieldValue(fieldName: string): undefined | string {
  try {
    const field = document.getElementsByName(fieldName)[0] as HTMLInputElement;
    if (field.value !== "") return field.value;
  } catch (e) {
    return undefined;
  }
  return undefined;
}
export function getFieldDateValue(fieldName: string): undefined | Date {
  try {
    const value = getFieldValue(fieldName);
    if (!value) return undefined;
    const date = toDate(value);
    if (!date) return undefined;
    return date;
  } catch (e) {
    return undefined;
  }
}
